import React from 'react';


import { useActions, useAppState } from 'state';
import { VehicleFragment } from 'state/gql/_types';

import { extractCurrentItemData } from "utils/forms";
import FormDrawer from 'components/forms/FormDrawer';

import { DrawerActionProps } from 'components/layout/page/PageDrawerAction';

import FormSchema from 'components/tenant/order/schemas/verify_vehicle_insurance.json';
import Icons from 'components/ui/Icons';
import OrderProcessAction from '../components/OrderProcessAction';
import { OrderActionProps } from './_types';
import { EditableVehicleFragment } from 'state/vehicles';

type FormPayloadType = Pick<VehicleFragment,
    | 'insurance_name'
    | 'insurance_number'
    | 'insurance_start_date'
    | 'insurance_end_date'
>

const initialState: FormPayloadType = {
    insurance_name: '',
    insurance_number: '',
    insurance_start_date: '',
    insurance_end_date: ''
};

const VerifyInsuranceDrawer: React.FC<DrawerActionProps<VehicleFragment>> = ({ currentItem, onClose }) => {

    const { updateItem } = useActions().vehicles;
    const { loading, errors } = useAppState().orders;

    let currentItemId = null;
    let currentItemData = null;
    if (currentItem) {
        currentItemId = currentItem.id;
        currentItemData = extractCurrentItemData<FormPayloadType>(initialState, currentItem);
    }

    return (
        <>
            <FormDrawer<FormPayloadType, VehicleFragment, string>
                autoOpen={false}
                formSchema={FormSchema}
                updateAction={updateItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
            />
        </>
    )
}

export const VerifyVehicleInsuranceAction: React.FC<OrderActionProps> = ({isValid}) => {

    const currentOrder = useAppState(state=>state.orders.currentItem)

    if (!currentOrder||!currentOrder.vehicle) return null;

    return (
        <OrderProcessAction<DrawerActionProps<EditableVehicleFragment>>
            title={isValid?'Update Vehicle Insurance':'Set Vehicle Insurance'}
            action={VerifyInsuranceDrawer}
            icon={Icons.edit}
            props={{currentItem:currentOrder.vehicle}}
            variant={isValid?"outline":"filled"}
            color={isValid?"gray":"blue"}
        />
    )
}